export default __webpack_public_path__ + "static/media/function-3.93cd5b86.png";